/** ColorRect parser: the Control parse plus a solid fill colour. */
/** The Godot default of `color` (class_colorrect). Godot omits a property at its default, so an absent `color` is opaque white. */
const DEFAULT_COLOR = 'Color(1, 1, 1, 1)';
import { parseControl } from '../control/parser';
export function parseColorRect(heading, properties) {
    const result = { ...parseControl(heading, properties) };
    result.color = properties.color || DEFAULT_COLOR;
    return result;
}
//# sourceMappingURL=parser.js.map